import React from "react";
import { cn } from "@ndd/ui";
import { FUNNEL_DOT_CLASSES, type FunnelGapView } from "../../../lib/metrics-display";

export function FunnelGapRow({ gap }: { gap: FunnelGapView }) {
  const dotClass = FUNNEL_DOT_CLASSES[gap.status];

  return (
    <div className="flex h-[26px] items-center gap-[14px]">
      <div className="w-[150px] shrink-0" />
      <div className="flex min-w-0 flex-1 items-center gap-3 text-body-sm text-muted-foreground">
        <span className="h-px flex-1 bg-border" />
        <span className="inline-flex items-center gap-[6px] whitespace-nowrap">
          {dotClass && (
            <span
              role="img"
              aria-label={`Target status: ${gap.status}`}
              className={cn("inline-block h-2 w-2 shrink-0 rounded-full", dotClass)}
            />
          )}
          <span>
            Drop-off <b className="text-foreground">{gap.dropOffPercent}%</b> ·{" "}
            {gap.targetText}
          </span>
        </span>
        <span className="h-px flex-1 bg-border" />
      </div>
      <div className="w-[120px] shrink-0" />
    </div>
  );
}
